export const nodeText = {
  primary:   { light: "#005F73", dark:  "#f1f5f9"},
  secondary: { light: "#92AD94", dark:  "#d5d8db"},
  input:     { light: "#001219", dark: "#f8fafc" }
};
